export default __webpack_public_path__ + "static/media/Nergal's Ring of the Burning Sky.6fe0394e.jpg";